module.exports = __webpack_public_path__ + "img/chevronUp.9eb365c9.svg";